class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.remove()
      document.body.appendChild(this)
    }

    connectedCallback (){
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.preventVariantURLSwitching();
            super.show(opener);

            const variantSelects = this.modalContent.querySelector('variant-selects');

            if (variantSelects) {
                variantSelects.dispatchEvent(new Event('change'));

                try {
                    const variantData = JSON.parse(variantSelects.querySelector('[type="application/json"]').textContent);
                    const options = Array.from(variantSelects.querySelectorAll('select'), s => s.value);
                    const currentVariant = variantData.find(v =>
                        !v.options.map((opt, i) => options[i] === opt).includes(false)
                    );

                    if (currentVariant) {

                        const available = currentVariant.hasOwnProperty('availability')
                        ? currentVariant.availability
                        : currentVariant.available;

                        const productForm = document.getElementById(`product-form-${variantSelects.dataset.section}`);

                        if (productForm) {
                            const addButton = productForm.querySelector('[name="add"]');
                            const addButtonText = productForm.querySelector('[name="add"] > span');

                            if (addButton && addButtonText) {
                                if (!available) {
                                    addButton.setAttribute('disabled', 'disabled');
                                    addButtonText.textContent = window.variantStrings.soldOut;
                                } else {
                                    addButton.removeAttribute('disabled');
                                    addButtonText.textContent = window.variantStrings.addToCart;
                                }
                            }
                        }
                    }
                } catch (e) {}
            }
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
}


customElements.define('quick-add-modal',QuickAddModal)
